import React, { useState, useEffect } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import form from "../../assets/chauffer/car2.png";
import { useNavigate } from "react-router-dom";

const ChauffeurBooking = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    travelStartDate: "",
    travelEndDate: "",
    message: "",
    carType: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show success message
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);

    // Reset form
    setFormData({
      fullName: "",
      email: "",
      phoneNumber: "",
      travelStartDate: "",
      travelEndDate: "",
      message: "",
      carType: "",
    });
  };

  return (
    <section>
      <div className="py-24 px-8">
        <div className="min-h-screen flex items-center justify-center">
          <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">

              {/* Left */}
              <div className="md:flex md:flex-col md:justify-center px-4 py-4 md:px-10 mb-5">

                <div className="flex justify-start mb-12">
                  <button
                    type="button"
                    onClick={() => navigate("/chauffeur")}
                    className="bg-[#5B656F] hover:bg-[#3a4558] text-white text-sm md:text-sm font-medium md:py-2 py-2 md:px-4 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1 md:gap-2"                  >
                    <MdOutlineKeyboardBackspace className="text-sm" />
                    Back
                  </button>
                </div>

                {/* Added font classes here */}
                <h1 className="md:text-3xl text-2xl font-bold font-[Raleway] text-gray-900 mb-2">
                  Chauffeur Booking
                </h1>
                <p className="text-gray-600 mb-8 font-[Rufina]">
                  Fill the details to book your trip
                </p>

                {/* Added font class to form */}
                <form onSubmit={handleSubmit} className="space-y-6 font-[Raleway]">

                  {/* Name + Email */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div className="relative">
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Full Name
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Email
                      </label>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="relative">
                    <input
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                      required
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      Phone Number
                    </label>
                  </div>

                  {/* Dates */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div className="relative">
                      <input
                        type="date"
                        name="travelStartDate"
                        value={formData.travelStartDate}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Travel Start Date
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="date"
                        name="travelEndDate"
                        value={formData.travelEndDate}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Travel End Date
                      </label>
                    </div>
                  </div>

                  {/* Car Type */}
                  <div className="relative">
                    <select
                      name="carType"
                      value={formData.carType}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                      required
                    >
                      <option value="">Select Car</option>
                      <option value="Maruti XL6">Maruti XL6</option>
                      <option value="Toyota Hycross">Toyota Hycross</option>
                    </select>
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      Car Type
                    </label>
                    {/* Added dropdown arrow icon */}
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="relative">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="3"
                      className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      Message
                    </label>
                  </div>

                  {/* Success Message */}
                  {showSuccess && (
                    <div className="p-3 bg-green-100 text-green-700 text-center rounded-lg font-[Raleway]">
                      Form submitted successfully!
                    </div>
                  )}

                  {/* Submit */}
                  <button
                    type="submit"
                    className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 rounded-lg flex items-center justify-center gap-2 transition-colors duration-200"
                  >
                    Submit Booking
                    <FiArrowUpRight className="text-xl" />
                  </button>

                </form>
              </div>

              {/* Right Image */}
              <div className="hidden lg:flex items-center justify-center">
                <img
                  src={form}
                  alt="Booking Form"
                  className="w-full h-full object-cover rounded-tr-[40px]"
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChauffeurBooking;